export default __webpack_public_path__ + "static/media/sbo-icon.013e9afa.svg";